import { useFeatureTheme } from '../../../theme/hooks/useFeatureTheme';

export default function useUserTheme() {
  return useFeatureTheme();
}
